import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Target, Brain, TrendingUp, XCircle } from 'lucide-react';
export function Features() {
  const features = [{
    icon: <Zap className="w-8 h-8 text-blue-600" data-id="element-50" />,
    title: 'Tu material publicitario en minutos',
    description: 'Cargás tu marca una vez y la IA arma creativos, copys y ángulos según tu nicho.'
  }, {
    icon: <Target className="w-8 h-8 text-blue-600" data-id="element-51" />,
    title: '50 ángulos de venta distintos',
    description: 'La IA te da 50 enfoques psicológicos para vender lo mismo de formas diferentes (problema, deseo, urgencia, prueba social y más).'
  }, {
    icon: <Brain className="w-8 h-8 text-blue-600" data-id="element-52" />,
    title: 'Creativos con texto integrado que convierten',
    description: 'Imágenes con tu logo, tu paleta y tu mensaje renderizados de forma nativa. Calidad de agencia, en segundos.'
  }, {
    icon: <TrendingUp className="w-8 h-8 text-blue-600" data-id="element-53" />,
    title: 'Todo listo para publicar',
    description: 'Descargás tus creativos, elegís tus copys y tu segmentación, seguís el checklist y publicás. Vos tenés el control.'
  }];
  const painPoints = [{
    title: 'Publicidad que se siente cara y no rinde',
    description: 'Pagás campañas que no traen clientes porque el mensaje y el creativo no están alineados.'
  }, {
    title: 'Perdés horas entre la idea y el anuncio',
    description: 'Escribir textos, diseñar piezas, pensar a quién apuntar… y el tráfico llega tarde.'
  }, {
    title: 'No sabés por dónde empezar',
    description: 'Sentís que necesitás saber de marketing, diseño y Meta Ads para no quemar plata.'
  }, {
    title: 'No tenés creativos ni copys que enganchen',
    description: 'Publicás lo que podés, no lo que convierte.'
  }];
  return <div className="bg-white py-20" data-id="element-54">
      <div className="max-w-5xl mx-auto px-4" data-id="element-55">
        {/* Features Section */}
        <div className="mb-24" data-id="element-56">
          <div className="text-center mb-12" data-id="element-57">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-58">
              ⚡ ¿QUÉ VAS A ENCONTRAR ADENTRO?
            </h2>
            <p className="text-lg text-slate-600" data-id="element-59">
              Todo en un solo lugar, sin instalar nada.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-60">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-slate-50 rounded-2xl p-8 border border-slate-100 hover:shadow-lg transition-shadow" data-id="element-61">
                <div className="bg-blue-100 w-16 h-16 rounded-xl flex items-center justify-center mb-6" data-id="element-62">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-63">
                  {feature.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-64">
                  {feature.description}
                </p>
              </motion.div>)}
          </div>

          <div className="mt-12 text-center bg-blue-50 rounded-2xl p-6 border border-blue-100" data-id="element-65">
            <p className="text-lg font-medium text-blue-900" data-id="element-66">
              Es un sistema interactivo, no un PDF: no lo leés y lo guardás —
              entrás y generás TU material con IA.
            </p>
          </div>
        </div>

        {/* Pain Points Section */}
        <div data-id="element-67">
          <div className="text-center mb-12" data-id="element-68">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-69">
              ✕ ¿TE SENTÍS IDENTIFICADO?
            </h2>
            <p className="text-lg text-slate-600" data-id="element-70">
              Si alguno de estos problemas te suena, esto es para vos:
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-71">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex gap-4 p-6 rounded-2xl bg-red-50/50 border border-red-100" data-id="element-72">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-73" />
                <div data-id="element-74">
                  <h3 className="font-bold text-slate-900 mb-2" data-id="element-75">
                    {point.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed" data-id="element-76">
                    {point.description}
                  </p>
                </div>
              </motion.div>)}
          </div>

          <div className="text-center mt-12" data-id="element-77">
            <p className="text-xl font-medium text-blue-800 bg-blue-50 inline-block px-6 py-3 rounded-full" data-id="element-78">
              Si dijiste "sí" a alguno… tenemos la solución. 👇
            </p>
          </div>
        </div>
      </div>
    </div>;
}